// extracted by mini-css-extract-plugin
module.exports = {"fill-parent":"fill-parent__3x6Mn","nav-item":"nav-item__EaZXv","nav-item__link":"nav-item__link__CFA1m","nav-item__link--active":"nav-item__link--active__3t3DV"};